<template>
  <div class="button-group button-create">
    <!-- <a href title class="btn btn--icon" :class="{ active: active }" @click.prevent="toggleActive()">
      <span class="icon-plus">
        <img src="/assets/img/icons/add-journal.png" width="18" height="18" alt="icon-add" loading="lazy" />
    <i class="add-journal"/>
     </span>
      <span class="btn-icon-text">Add</span>
    </a>
    <div class="button-link">
      <a href="/review/add" title class="button-link__item" target="_blank" @click.prevent="openModalSearchProduct">
        <div class="button-link__wrap">
          <span class="icon">
            <img
              src="/assets/img/icons/write-review.svg"
              alt="icon-write-review"
              loading="lazy"
              width="32"
              height="32"
            />
          </span>
          <span class="text">write review</span>
        </div>
      </a> -->
    <a href="javascript:0" title class="btn btn--icon" @click.prevent="openModalSearchProduct">
      <span class="icon-plus">
        <img src="/assets/img/add-journal-new.png" width="24" height="24" alt="icon-add" loading="lazy" />
        <!-- <i class="add-journal"/> -->
      </span>
      <span class="btn-icon-text">Add</span>
    </a>

    <!-- <a href="/add-product" @click.prevent="addProduct()" title class="button-link__item" v-if="isLogin && isVerifiedPhone"> -->
    <!-- <a v-if="isLogin" href="/add-product" title class="button-link__item" @click.prevent="addProduct()">
        <div class="button-link__wrap">
          <span class="icon">
            <img src="/assets/img/icons/add-video.svg" alt="icon-add-product" loading="lazy" width="32" height="32" />
          </span>
          <span class="text">add product</span>
        </div>
      </a> -->
    <!-- <a href="" @click.prevent="$store.commit('toggleModalGlobalState', {modalName: 'otpCode'})" title class="button-link__item" v-else-if="isLogin && !isVerifiedPhone">
        <div class="button-link__wrap">
          <span class="icon">
            <img loading="lazy" src="/assets/img/icons/add-video.svg" />
          </span>
          <span class="text">add product</span>
        </div>
      </a> -->
    <!-- <a v-else href="" title class="button-link__item" @click.prevent="openAddProduct">
        <div class="button-link__wrap">
          <span class="icon">
            <img src="/assets/img/icons/add-video.svg" alt="icon-add-video" loading="lazy" width="32" height="32" />
          </span>
          <span class="text">add product</span>
        </div>
      </a> -->
    <!-- </div> -->

    <ModalOtpCode
      v-if="isModalOtpCodeShow"
      :user-phone-number="userPhoneNumber"
      :skippable="false"
      :email-verification="false"
      :state="state"
    >
    </ModalOtpCode>

    <ModalChangeNumber v-if="isModalChangeNumberShowing" />
  </div>
</template>

<script>
import ModalOtpCode from '@/components/global/modal/ModalOtpCode';
import ModalChangeNumber from '@/components/global/modal/ModalChangeNumber';
import Auth from '@/shared/auth';

export default {
  name: 'button-create',
  components: {
    ModalOtpCode,
    ModalChangeNumber,
  },
  data() {
    return {
      active: false,
      state: '',
    };
  },
  computed: {
    isLogin() {
      return this.$store.state.auth.loggedin;
    },
    userProfile() {
      return this.$store.state.userProfile;
    },
    userPhoneNumber() {
      const userProfile = this.$store.state.userProfile;
      return userProfile && 'phone_no' in userProfile ? userProfile.phone_no : '';
    },
    isModalOtpCodeShow() {
      return this.$store.state.modal.isModalShow.otpCode;
    },
    isVerifiedPhone() {
      const userProfile = this.$store.state.userProfile;
      return userProfile && 'is_verified_phone' in userProfile ? userProfile.is_verified_phone : false;
    },
    isModalChangeNumberShowing() {
      return this.$store.state.modal.isModalShow.changeNumber;
    },
    isDesktop() {
      return this.$store.state.screen.isDesktop;
    },
  },
  created() {
    document.addEventListener('click', this.documentClick);
  },
  destroyed() {
    document.removeEventListener('click', this.documentClick);
  },
  methods: {
    addProduct() {
      this.state = 'product';
      this.active = false;
      this.$router.push('/add-product');
    },
    documentClick(e) {
      const target = e.target;

      if (this.active) {
        if (this.$SO(target).closest('.button-create').length < 1) {
          this.active = false;
        }
      }
    },
    openAddProduct() {
      this.$store.commit('setRedirectURL', '/add-product');

      this.openLoginOtf();
    },

    openLoginOtf() {
      this.active = false;
      Auth.CentralAuth.login();
    },
    openModalSearchProduct() {
      this.$store.dispatch('userBlockedToReviewCheck').then((isBlocked) => {
        if (isBlocked) {
          return;
        }
        this.state = '';
        if (this.isLogin) {
          if (this.isDesktop) {
            this.$store.commit('toggleModalGlobalState', { modalName: 'shareExperience' });
          } else {
            this.$router.push('/review/add');
          }
        } else {
          if (this.isDesktop) {
            Auth.CentralAuth.login();
          } else {
            this.$store.commit('setRedirectURL', '/review/add');
            this.state = 'openModalSearchProduct';
            this.openLoginOtf();
          }
        }
        this.active = false;
        document.body.classList.remove('no-scroll');
      });
    },
    toggleActive() {
      this.active = this.active ? false : true;
    },
  },
};
</script>
<style lang="scss" scoped>
.icon-plus {
  height: 30px;
}
</style>
